import GameFeatureCreate from './game-feature.create';
import GameFeatureEdit from './game-feature.edit';

export default {
  create: GameFeatureCreate,
  edit: GameFeatureEdit,
};
